import React, { forwardRef, useState, useCallback, useMemo, useRef } from 'react'
import { FieldTypes } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import AquasecMappingForm from './AquasecMappingForm';
import { isNil } from 'utils/lodashUtils';

function AquasecCredentialsForm(props, ref) {
    //false type would set Cloud configuration
    //initially value set for cloud config
    const [type, setType] = useState(()=> props.config?.isOnPrem ? props.config?.isOnPrem : "false");
    const [cloudAuthType, setCloudAuthType] = useState(() => props.config ? !isNil(props.config?.csp_roles) && isNil(props.config?.email) ? "tokenAuth" : "emailPasswordAuth" : "");
    const handleRadioChange = useCallback((e) => {
        setType(e.target.value);
    }, []);
    const passwordFieldRef = useRef({
        name: "password",
        label: "Password",
        type: FieldTypes.PASSWORD,
        required: true
    })
    const fields = useMemo(()=> [
    {
        name: "isOnPrem",
        type: FieldTypes.RADIO,
        options: [
            {
                label: 'Aqua cloud',
                value: "false"
            },
            {
                label: 'On-prem',
                value: "true"
            }
        ],
        props: {
            onChange: handleRadioChange,
            defaultValue: type
        }
    },
    ...(
        type === "true"
            ?
            [
                {
                    name: "apiEndpoint",
                    label: "Aqua Endpoint",
                    required: true,
                },
                {
                    name: "username",
                    label: "User Name",
                    required: true
                }
            ]
            :
            [
              {
                label: "Select Authentication Mechanism",
                name: "cloudAuthType",
                type: FieldTypes.SELECT,
                options: [
                  {
                    label: "Token Authentication", 
                    value: "tokenAuth"
                  },
                  {
                    label: "User Authentication", 
                    value: "emailPasswordAuth"
                  }
                ],
                props: {
                  onChange: setCloudAuthType
                }
              },
              ...(cloudAuthType === "tokenAuth" ? [
                {
                  name: "apiKey",
                  label: "API Key",
                  type: FieldTypes.PASSWORD,
                  required: true
                },
                {
                  name: "secretKey",
                  label: "Secret Key",
                  type: FieldTypes.PASSWORD,
                  required: true,
                },
                {
                  name: "csp_roles",
                  label: "CSP Roles",
                  required: true
                },
              ] : 
              [
                  {
                      name: "email",
                      label: "Email",
                      required: true
                  }
              ])               
            ]
    ),
    ...(cloudAuthType !== "tokenAuth" ? [passwordFieldRef.current] : [])
    ], [handleRadioChange, type, cloudAuthType]);

    const beforeSave = useCallback((data) => {
        data.isOnPrem = data.isOnPrem === "true" ? true : false;
        return data;
    }, []);

    const parseExtraFields = useCallback((config) => {
       return {...config, apiEndpoint: 'https://api.aquasec.com/',  cloudAuthType} 
    }, [cloudAuthType]);

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={AquasecMappingForm}
            beforeSave={beforeSave}
            parseExtraFields={parseExtraFields}
        />
    )
}

export default forwardRef(AquasecCredentialsForm);